<template>
  <div :class="$style.container">
    <!-- Иконка для информации о платильщике -->
    <div :class="$style.preview">
      <base-icon
        v-p-t="4"
        v-color:black-2
        name="basic_user"
      />
    </div>
    <!-- Блок контента платежной информации -->
    <div v-grow>
      <div v-d-flex v-align="{ items: 'flex-start' }">
        <!-- Личная информация платильщика -->
        <div v-word-break:break-word>
          <!-- Имя платильщика (опционально) -->
          <div
            v-if="sender.name"
            :class="$style.name"
            v-text="sender.name"
          ></div>
          <!-- Емейл платильщика (опционально) -->
          <div
            v-if="sender.email"
            :class="$style.email"
          >
            <base-link
              v-color:violet
              v-text-decoration:underline
              :href="`mailto:${sender.email}`"
            >
              {{ sender.email }}
            </base-link>
          </div>
          <!-- Телефон платильщика (опционально) -->
          <div
            v-if="sender.phone"
            :class="$style.phone"
            v-text="sender.phone"
          />
          <!-- Описание для платежа (опционально) -->
          <div
            v-if="sender.description"
            :class="$style.description"
            v-text="sender.description"
          />
        </div>
        <!-- Оценка платежа (при наличии личной информации платильщика) -->
        <div v-if="rating && !isEmptySender" :class="$style.rating">
          <transaction-rating :rating="rating" />
        </div>
      </div>

      <template v-if="payment">
        <!-- Разделитель показываем при наличии личной информации платильщика -->
        <hr
          v-if="!isEmptySender"
          :class="$style.delimiter"
        />
        <div
          v-d-flex
          v-align="{ items: 'flex-start' }"
        >
          <div v-if="cryptoAccrualCount > 0">
            <base-link
              v-color:violet
              v-text-decoration:underline
              :href="cryptoTransactionHistoryLink"
              target="_blank"
            >
              {{ displayCryptoAccrual }}
            </base-link>
          </div>
          <!-- Информация о средствах совершения платежа -->
          <payment-method
            v-else
            :payment-method="payment.paymentMethod"
            :account-number="payment.accountNumber"
            :card-ps-type="payment.cardPsType"
          />
          <!-- Оценка платежа (при отсутствии личной информации платильщика) -->
          <div v-if="rating && isEmptySender" :class="$style.rating">
            <transaction-rating :rating="rating" />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import BaseLink from 'atoms/base/BaseLink';
import PaymentMethod from 'molecules/transaction/details/PaymentMethod';
import TransactionRating from 'molecules/transaction/details/TransactionRating';

export default {
  name: 'SenderInformation',
  components: {
    BaseLink,
    PaymentMethod,
    TransactionRating,
  },
  props: {
    sender: {
      type: Object,
      required: true,
    },
    payment: {
      type: Object,
      required: false,
      default: () => null,
    },
    rating: {
      type: Object,
      default: () => null,
    },
  },
  computed: {
    isEmptySender() {
      const callback = (value) => this.$validate.isNull(value);

      return this.$validate.isObjectValuesValidByCallback(this.sender, callback);
    },
    cryptoAccrualCount() {
      return this.payment.cryptoAccrualCount || 0;
    },
    cryptoTransactionHistoryLink() {
      return this.payment.cryptoTransactionHistoryLink || null;
    },
    displayCryptoAccrual() {
      return this.$t('transaction.content.crypto.accrual', {
        count: this.cryptoAccrualCount,
      });
    },
  },
};
</script>

<style lang="sass" module>
  .container
    +flexbox

  .preview
    +flexbox
    +align-self(flex-start)
    flex: none
    margin-right: 26px

  .name
    +font-type('bold', 14, 21)
    color: var(--color-black-2)
    margin-bottom: 2px

  .email
    +line-height(21)
    margin-bottom: 2px

  .phone
    +font-type('medium', 14, 21)
    color: var(--color-black-2)
    margin-bottom: 2px

  .description
    +font-type('medium', 12, 18)
    margin-top: 5px
    padding: 16px 20px
    border-radius: 0 8px 8px 8px
    background-color: rgba(33, 33, 33, 0.1)

  .rating
    flex: none
    margin-left: auto

  .delimiter
    height: 1px
    margin: 20px 0
    border-color: rgba(39, 40, 60, 0.1)
</style>
